import React from "react";
import { ReactTableDefaults } from "react-table";
import { subscribeToActivity } from "./activityIndicator";
import "./reactTableEmpty.css";

// react-table v6 draws `defaultPageSize` blank rows when it has no data, and
// says nothing about why. That is what an admin sees for the first seconds of
// every list page in this app — a full grid of empty rows that reads as
// "broken" rather than "loading" (the Invoice list is the reported case).
//
// 77 files render a react-table, so this replaces the empty state once,
// globally, via the v6 defaults object rather than per table. The message is
// tied to the same in-flight read counter the top loading bar uses, so it can
// tell the two situations apart: data on the way, versus genuinely no rows.

class TableEmptyState extends React.Component {
  state = { busy: false };

  componentDidMount() {
    this.unsubscribe = subscribeToActivity((busy) => this.setState({ busy }));
  }

  componentWillUnmount() {
    if (this.unsubscribe) this.unsubscribe();
  }

  render() {
    const { busy } = this.state;
    // `is-busy` is what tells the stylesheet the two states apart — waiting
    // for rows is a transient thing that should stay quiet, while a list that
    // really is empty gets the full treatment (_react-table.scss also hides
    // the header and pager off the back of this element being here).
    return (
      <div
        className={`alg-table-empty ${busy ? "is-busy" : "is-empty"}`}
        role="status"
        aria-live="polite"
      >
        {busy ? (
          <>
            <span className="alg-table-empty-spinner" />
            Loading…
          </>
        ) : (
          <>
            <span className="alg-table-empty-art" aria-hidden="true" />
            <span className="alg-table-empty-title">Nothing here yet</span>
            <span className="alg-table-empty-note">
              No rows to show for this view
            </span>
          </>
        )}
      </div>
    );
  }
}

ReactTableDefaults.NoDataComponent = TableEmptyState;

export default TableEmptyState;
